<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:titulo-modal="tituloModalExclusao"
			:subtitulo-modal="subtituloModalExclusao"
			:mensagem="mensagemModalExclusao"
			@confirmar="acaoConfirmarExclucaoRevisao"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>

<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-excluir-revisao',
	components: { ModalConfirmacao },
	props: {
		exibir: Boolean,
	},
	emits: ['fechar-modal', 'confirmar-exclusao-revisao'],
	data() {
		return {
			mensagemModalExclusao: 'Deseja realmente confirmar esta ação?',
			tituloModalExclusao: 'Atenção! Você está prestes a excluir esse tipo de Revisão.',
			subtituloModalExclusao: 'Após a exclusão você não poderá recuperá-lo!',
		}
	},
	methods: {
		acaoConfirmarExclucaoRevisao() {
			this.$emit('confirmar-exclusao-revisao')
		},
	},
}
</script>
